import * as Highcharts from 'highcharts';

export function shouldAllowAxisDecimals(
  dataMin: number | undefined,
  dataMax: number | undefined,
  smallValueMax: number
): boolean {
  const maxAbs = Math.max(Math.abs(dataMin ?? 0), Math.abs(dataMax ?? 0));
  return maxAbs > 0 && maxAbs <= smallValueMax;
}

export function syncYAxisDecimals(
  chart: Highcharts.Chart,
  smallValueMax: number
): void {
  const yAxis = chart.yAxis?.[0];
  if (!yAxis) return;

  const { dataMin, dataMax } = yAxis.getExtremes();
  const allowDecimals = shouldAllowAxisDecimals(
    dataMin,
    dataMax,
    smallValueMax
  );

  if ((yAxis.options.allowDecimals ?? false) !== allowDecimals) {
    yAxis.update({ allowDecimals }, true);
  }
}
